
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';


const getAll = async ( params = {} ) => {

  const query = `
    query GetTerapias(
      $search: String
    ) {
      terapias(
        search: $search
      ) {
        id
        nombre
        codigo
      }
    }
  `;
  
  const variables = { ...params };

  try{

    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;

    const response2 = response.data.data.terapias;
    if( !response2 ) return null;

    const data = response2;
    return data;


  }catch(error){
    console.error("Error:", error.response ? error.response.data : error);
    return null;
  }
}


export const terapiasCarteraService = {
  getAll
}
  
